module.exports = __webpack_public_path__ + "static/media/guidance_bg.ae0fe7ca.jpg";